import { z } from 'zod';

/**
 * A nullable euro cap: whole cents only (tolerating the float noise of a typed decimal such as
 * 19.99), never negative. `null` means "no cap on this axis". Messages are translation keys,
 * resolved by the caller's own `t()`.
 */
export const wholeEuroCap = ({
  minKey,
  centsKey,
}: {
  minKey: string;
  centsKey: string;
}) =>
  z
    .number()
    .min(0, minKey)
    .refine((euros) => Math.abs(euros * 100 - Math.round(euros * 100)) < 1e-6, {
      message: centsKey,
    })
    .nullable();
